<template>
  <div class="choice-answer" @mouseover="handleMouseHover" @mouseleave="handleMouseLeave">
    <div class="choice-answer__controls" :class="{ disabled: item && item.correct_answer }">
      <vfocus-field>
        <vcheckbox v-if="type === 'multiple'" class="answer" />

        <vcircle v-if="type === 'single'" class="answer" />
      </vfocus-field>
    </div>

    <vinput
      class="choice-answer__input"
      border
      :value="item.content"
      :placeholder="$tr('vacancy.preferences.application.answer')"
      :disabled="item.type === 'other'"
      :focus="answer_focus"
      :error="answer_error(item.content)"
      @input="set_answer($event, item.id)"
    />

    <div v-if="isDropoutModuleEnabled" class="cut-option">
      <div v-if="!item.is_dropout">
        <div v-if="mouseHover && mouseLeave" @click="setCutOptioin(item, true)">
          {{ $tr('vacancy.preferences.application.dropout') }}
        </div>
      </div>

      <div v-if="item.is_dropout">
        <div v-if="!mouseHover || !mouseLeave">
          {{ $tr('vacancy.preferences.application.addAnswers4') }}
        </div>

        <div v-if="mouseHover && mouseLeave" @click="setCutOptioin(item, false)">
          {{ $tr('vacancy.preferences.application.noDropout') }}
        </div>
      </div>
    </div>

    <div class="choice-answer__delete" @click="del_answer(item)">
      <i class="icon icon-recycle_bin"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Answer',

  props: ['item', 'type', 'answer_focus', 'isDropoutModuleEnabled'],

  data() {
    return {
      mouseHover: false,
      mouseLeave: true
    };
  },

  methods: {
    set_answer(v, answ_id) {
      console.log(v);
      console.log(answ_id);
      this.$emit('set_answer', { answ_id, v });
    },

    setCutOptioin(item, isTrue = false) {
      this.mouseLeave = false;
      this.$emit('setCutOptioin', { item, isTrue });
    },

    answer_error(v) {
      if (v === '') {
        return this.$tr('common.requiredField');
      } else {
        return '';
      }
    },

    del_answer(v) {
      this.$emit('del_answer', v);
    },

    handleMouseHover() {
      this.mouseHover = true;
    },

    handleMouseLeave() {
      this.mouseHover = false;
      this.mouseLeave = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.choice-answer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  &__controls {
    margin-right: 17px;
    opacity: 0.5;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__input {
    flex: 1;
    margin-top: 0;
  }

  &__delete {
    font-size: 20px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      color: $grey;
      transition: color 0.3s;
    }

    &:hover i {
      color: $red;
      transition: color 0.3s;
    }
  }
}

.cut-option {
  @include mixin-text-tag;
  position: absolute;
  top: calc(50% - 9px);
  right: 50px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #9faab6;
  cursor: pointer;
}
</style>
